module.exports = __webpack_public_path__ + "static/media/foto7.4f317991.jpg";